import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { Card, Collapse, List, ListItem, ListItemButton, ListItemText, Typography } from "@mui/material";
import { MprcContainer, MprcRequestErrorReport, MprcRequestIndicator, MprcSpinnerIndicator } from "components";
import { Formaters } from "lib/Formaters";
import { useCoreApi } from "providers/CoreApiProvider";
import { useSession } from "providers/SessionProvider";
import * as React from "react";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

/////////////////////////////////////////////////////////////////////////////////////

interface IData {
    releaseNumber: string;
    releaseDate: Date;
    releaseNotes: string;
    open: boolean;
}

/////////////////////////////////////////////////////////////////////////////////////

export const ReleaseNotes: React.FC = () => {

    const { t } = useTranslation();
    const session = useSession();
    const api = useCoreApi();

    const [loading, setLoading] = useState<boolean>(true);
    const [releaseNumber, setReleaseNumber] = useState<string>("");
    const [data, setData] = useState<IData[]>(null!);
    const lastError = useRef<any>(null);

    ///
    const handleClick = (releaseNumber: string) => {
        var newData = [...data];
        var d = newData.find(x => x.releaseNumber == releaseNumber);
        if (d) {
            d.open = !d.open;
            if (d.releaseNotes == null) setReleaseNumber(releaseNumber);
            setData(newData);
        }
    };

    ///
    useEffect(() => {
        async function loadData() {
            try {
                var result = await api.v1.system.getReleaseNotes();
                setData(result.data.map((v) => {
                    return {
                        open: v.releaseNumber == session.appBuild?.buildVersion,
                        releaseDate: v.releaseDate,
                        releaseNumber: v.releaseNumber
                    } as IData;
                }));
                setReleaseNumber(session.appBuild?.buildVersion ?? "");
            } catch (error) {
                lastError.current = error;
            }
            finally {
                setLoading(false);
            }
        }

        loadData();
    }, []);

    ///
    useEffect(() => {
        async function loadReleaseNote() {
            try {
                var result = await api.v1.system.getReleaseNote({ releaseNumber });

                var newData = [...data];
                var d = newData.find(x => x.releaseNumber == releaseNumber);
                if (d) {
                    d.releaseNotes = result.data;
                    setData(newData);
                }
            }
            catch (error) {
                lastError.current = error;
            }
        }
        if (releaseNumber != "") loadReleaseNote();
    }, [releaseNumber]);


    return (
        <div>
            {
                lastError.current
                    ? <MprcRequestErrorReport error={lastError.current} />
                    : loading
                        ? <MprcRequestIndicator type="waiting" />
                        : (
                            <div>
                                <MprcContainer>
                                    <Typography variant="h2">
                                        {t("Public.ReleaseNotes.Title")}
                                    </Typography>
                                </MprcContainer>
                                {
                                    data.map((v, index) => {
                                        return (
                                            <MprcContainer margin="dense" key={index}>
                                                <Card>
                                                    <List component="nav">
                                                        <ListItemButton onClick={() => handleClick(v.releaseNumber)}>
                                                            <ListItemText primary={<span><b>{v.releaseNumber}</b> ({Formaters.localeDate(v.releaseDate)})</span>} />
                                                            {v.open ? <ExpandLess /> : <ExpandMore />}
                                                        </ListItemButton>
                                                        <Collapse in={v.open} timeout="auto" unmountOnExit>
                                                            <ListItem>
                                                                {
                                                                    v.releaseNotes == null
                                                                        ? <MprcSpinnerIndicator />
                                                                        : <pre>{v.releaseNotes}</pre>
                                                                }
                                                            </ListItem>
                                                        </Collapse>
                                                    </List>
                                                </Card>
                                            </MprcContainer>
                                        );
                                    })
                                }
                            </div>
                        )
            }

        </div>
    );
};
